import {
    Component,
    ChangeDetectionStrategy,
    OnInit,
    Input,
    Output,
    ChangeDetectorRef,
    OnDestroy,
    EventEmitter,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormHelperService, isEditOrRelistPage } from '@classifieds-sell/shared';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { Subject } from 'rxjs';
import { MotorsSectionBase } from '../motors-section-base';

@Component({
    selector: 'motors-vehicle-transfer-options-section',
    templateUrl: './motors-vehicle-transfer-options-section.component.html',
    styleUrls: ['./motors-listing-details.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MotorsVehicleTransferOptionsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('motorsVehicleTransferOptionsSectionForm')
    motorsVehicleTransferOptionsSectionForm: NgForm;

    constructor(
        public draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _formHelperService: FormHelperService,
        private route: ActivatedRoute
    ) {
        super(draftFacade);
    }

    @Input() selection: string;
    @Output() selectionChange = new EventEmitter<string>();

    vehicleTransferOptionsRadioSelection: string;
    buyerMustPickUp: string;
    buyerCanPickUp: string;
    toBeArranged: string;
    inputDisabled: boolean;

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    changeSelection() {
        this.selectionChange.emit(this.selection);
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.setInputDisable();
            this._changeDetectorRef.markForCheck();
        });
    }

    setInputDisable(){
        this.inputDisabled = this.metadata.bidCount > 0;
    }

    isValid(): boolean {
        this._formHelperService.validate(
            this.motorsVehicleTransferOptionsSectionForm
        );
        return this.formValidationWhenDisabled(this.motorsVehicleTransferOptionsSectionForm);
    }

    protected formValidationWhenDisabled(ngForm: NgForm): boolean {
        // When there is a bid, this becomes greyed out and read-only then all inputs are disabled => form should be valid
        const isFormDisabled = ngForm.form.disabled;
        return (((isEditOrRelistPage(this.route) && isFormDisabled)
            || ngForm.form.valid));
    }

    dirty(): boolean {
        return this.motorsVehicleTransferOptionsSectionForm.form.dirty;
    }
}
